import React, { Component } from "react";
import { Row, Col, Button, Modal, Container, Form } from "react-bootstrap";
import Switch from "react-switch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./EditBank.css";

class EditBank extends Component {
  constructor(props) {
    super(props);
    this.state = {
        name: this.props.ItemList ? this.props.ItemList.name : null,
        code: this.props.ItemList ? this.props.ItemList.code : null,
        desc: this.props.ItemList ? this.props.ItemList.desc : null,
        isActive: this.props.ItemList ? this.props.ItemList.isActive : true,
        id: this.props.ItemList ? this.props.ItemList.id : null,
    };
    this.selectCategry = this.selectCategry.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
        ...this.state,
        name: nextProps.ItemList && nextProps.ItemList.name,
        code: nextProps.ItemList && nextProps.ItemList.code,
        desc: nextProps.ItemList && nextProps.ItemList.desc,
        isActive: nextProps.ItemList && nextProps.ItemList.isActive,
        id: nextProps.ItemList && nextProps.ItemList.id,
    });
  }
  onChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    if (name == "name") {
      this.setState({
        ...this.state, name: value
      });
    } else if (name == "code") {
      this.setState({
         ...this.state, code: value 
      });
    } else if (name == "desc") {
      this.setState({
         ...this.state, desc: value 
      });
    }
  
  };

  selectCategry = e => {
    this.setState({...this.state, role: e.target.value  });
  };

  handleChange=()=>{
    this.setState({
      ...this.state,
      isActive:!this.state.isActive
    });
  }

  submit = () => {
    const {name, code, desc, isActive, id } = this.state;
    let data={name:name, code:code, desc:desc, isActive:isActive, id:id};
    
    if (
      name === "" &&
      code === "" &&
      desc === ""
    ) {
      toast.error("Please fill out this field", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER
      });
    } else {
      this.props.EditBank(data);
      this.props.closeEditModel();
      this.props.resetPage();
    }
  };
  
  render() {
    const { name, code, desc, isActive,id } = this.state;
    return (
      <div>
        <Modal
          show={this.props.showEditModel}
          onHide={this.props.closeEditModel}
          animation={false}
          size="md"
          backdrop="static"
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
            closeButton
          >
            <Modal.Title>Bank</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
            <Form>
                <Row>
                  <Col lg={6} sm={12} xs={12}>

                    <Form.Group controlId="name">
                      <Form.Label> Bank </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="name"
                        value={name}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group controlId="code">
                      <Form.Label> Bank Code</Form.Label>
                      <Form.Control
                        type="text"
                        name="code"
                        autoComplete="off"
                        value={code}
                        onChange={this.onChange}
                      />
                    </Form.Group>

                  </Col>
                </Row>
                <Row>
                <Col lg={6} sm={12} xs={12}>
                    <Form.Group controlId="desc">
                      <Form.Label> Description</Form.Label>
                      <Form.Control
                        type="text"
                        name="desc"
                        autoComplete="off"
                        value={desc}
                        onChange={this.onChange}
                      />
                    </Form.Group>

                  </Col>

                  <Col lg={6} sm={12} xs={12}>
                    <label style={{ display: "flex", marginTop: "0px" }}>
                      <Form.Group controlId="isActive">
                        <Form.Label>Active</Form.Label>
                        <div style={{ marginTop: "0px", marginLeft: "10px" }}>
                          <Switch
                            onChange={this.handleChange}
                            onColor="#20a8d8"
                            checked={isActive}
                          />
                        </div>
                      </Form.Group>
                    </label>
                  </Col>
                </Row>
              </Form>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
            <Button type="submit" onClick={this.submit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default EditBank;
